import { MapPin } from "lucide-react";
import { BUSINESS, waLink, WA_MESSAGES } from "@/lib/business";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FinalCta = () => (
  <section
    data-testid="final-cta-section"
    className="bg-stone-50"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
      <div
        data-reveal
        className="rounded-3xl bg-brand px-8 py-14 md:px-16 md:py-20 text-center shadow-lg"
      >
        <h2
          data-testid="final-cta-heading"
          className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white"
        >
          {BUSINESS.sloganStorefront}
        </h2>
        <p
          data-testid="final-cta-text"
          className="mt-4 mx-auto max-w-xl text-base sm:text-lg text-emerald-50"
        >
          Fale agora com a Ótica Danko e encontre o óculos ideal para você.
        </p>
        <a
          href={waLink(WA_MESSAGES.help)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-whatsapp-button"
          className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-brand shadow-md hover:bg-emerald-50 hover:shadow-lg btn-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand"
        >
          <WhatsAppIcon className="w-5 h-5" />
          Fale pelo WhatsApp
        </a>
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-brand-dark text-white"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
        <div>
          <img
            src="/assets/logo.png"
            alt="Logo da Ótica Danko"
            data-testid="footer-logo"
            className="h-12 w-auto rounded-md bg-white/95 p-1"
          />
          <p className="mt-4 text-sm text-emerald-100 italic">
            {BUSINESS.sloganLogo}
          </p>
        </div>

        <div className="space-y-3">
          <p
            data-testid="footer-address"
            className="flex items-start gap-2 text-sm text-emerald-50"
          >
            <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
            {BUSINESS.address}
          </p>
          <a
            href={waLink(WA_MESSAGES.general)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-emerald-200 transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            <WhatsAppIcon className="w-4 h-4" />
            WhatsApp: {BUSINESS.phoneDisplay}
          </a>
        </div>
      </div>

      <div className="mt-12 border-t border-white/15 pt-6">
        <p
          data-testid="footer-copyright"
          className="text-xs text-emerald-200"
        >
          © {new Date().getFullYear()} {BUSINESS.name}. Todos os direitos
          reservados.
        </p>
      </div>
    </div>
  </footer>
);
